export const adjectiveList = {
  0: ["witty", "smart", "genius", "brilliant"],
  1: ["inquisitive", "curious", "innovative", "inventive"],
  2: ["articulate", "eloquent", "silver-tongued", "poetic"],
  3: ["intuitive", "perceptive", "observant", "astute"],
  4: ["mature", "wise", "patient", "contemplative"],
  5: ["easy-going", "chill", "relaxed", "happy-go-lucky"],
  6: ["serene", "peaceful", "tolerant", "harmonious"],
  7: ["enigmatic", "mysterious", "sphinxlike", "transcendental"],
  8: ["elfin", "magical", "whimsical", "chimerical"],
  9: ["unique", "singular", "original", "weird"],
  10: ["artistic", "creative", "talented", "gifted"],
  11: ["playful", "fun", "mirthful", "free-spirited"],
  12: ["amicable", "friendly", "gregarious", "neighborly"],
  13: ["optimistic", "cheerful", "enthusiastic", "merry"],
  14: ["bubbly", "energetic", "vivacious", "full of life"],
  15: ["charming", "charismatic", "enchanting", "dazzling"],
  16: ["adorable", "cute", "darling", "precious"],
  17: ["broad-minded", "open-minded", "adaptable", "versatile"],
  18: ["honest", "sincere", "fair", "trustworthy"],
  19: ["hilarious", "funny", "jocular", "waggish"],
  20: ["kind", "compassionate", "empathetic", "understanding"],
  21: ["generous", "giving", "magnanimous", "altruistic"],
  22: ["moral", "just", "ethical", "righteous"],
  23: ["thoughtful", "considerate", "goodhearted", "warm"],
  24: ["gentle", "sweet", "affectionate", "nurturing"],
  25: ["judicious", "prudent", "conscientious", "sensible"],
  26: ["polite", "courteous", "humble", "modest"],
  27: ["decisive", "responsible", "stable", "dependable"],
  28: ["independent", "bold", "pioneering", "daring"],
  29: ["heroic", "lionhearted", "fearless", "courageous"],
  30: ["sophisticated", "regal", "cultured", "elegant"],
  31: ["ravishing", "sexy", "lovely", "captivating"],
  32: ["romantic", "passionate", "amorous", "ardent"],
  33: ["suave", "cool", "smooth", "dashing"],
  34: ["stoic", "strong", "tough", "confident"],
  35: ["diligent", "hardworking", "unflagging", "unstoppable"],
  36: ["ambitious", "proactive", "striving", "determined"],
  37: ["focused", "organized", "resourceful", "disciplined"],
  38: ["marvelous", "sensational", "spectacular", "magnificent"],
  39: ["inevitable", "star-far", "scrumdiddlyumptious", "the ultimate"],
};
